const DEV_HOST = 'https://dev.trazoevents.com'
let PROD_HOST = window.location.protocol + '//' + window.location.hostname

// PROD_HOST = PROD_HOST.replace('usuarios', 'cursos')

export const isDev = process.env.NODE_ENV === 'development'

export const baseAPIRoot = isDev ? `${DEV_HOST}/api` : `${PROD_HOST}/api`